<template>
  <el-drawer title="项目权限" :visible.sync="drawer" :wrapperClosable="false" size="52%" @open="open" @close="close">
    <div class="demo-drawer-content">11111111</div>
  </el-drawer>
</template>

<script>
export default {
  props: {
    drawerVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      drawer: this.drawerVisible,
      formData: {
        address: '',
        name: ''
      }
    }
  },
  //   watch: {
  //     drawerVisible(val) {
  //       console.log(val, 'valbbb')
  //       this.drawer = val
  //     }
  //   },
  methods: {
    open() {
      this.drawer = true
    },
    close() {
      this.$emit('drawerClose')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/drawer.scss';
</style>
